angular.module('tasks')
    .controller('TaskShowDialogController', function ($timeout, $location, $scope, $rootScope, $filter, $uibModalInstance, data, toastr, Task, Principal) {
        this.$onInit = () => {
            this.id = data;
            this.isPrivate = undefined;
            this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
            this.loadTask();
        }

        this.loadTask = () => {
            Task.get({id: this.id}).$promise
                .then(result => this.item = result)
                .catch(() => {
                    this.item = null;
                    this.isPrivate = true;
                });
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.$on('task.updated', () => this.loadTask());
        $scope.$on('task.deleted', () => this.cancel());
    })
    .component('taskShow', {
        bindings: {
            item: '<',
            action: '<',
            id: '<'
        },
        templateUrl: 'app/task/show.html',
        controller: function ($scope, $state, $window, TaskMeetingAttendanceService, Principal) {
            this.$onInit = () => {
                this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD'])
                switch (this.action) {
                    case 'accept':
                        TaskMeetingAttendanceService.accept(this.id).then(() => $state.go("taskShow", {id: this.id}))
                        break
                    case 'note':
                        TaskMeetingAttendanceService.note(this.id).then(() => $state.go("taskShow", {id: this.id}))
                        break
                    case 'reject':
                        TaskMeetingAttendanceService.reject(this.id).then(() => $state.go("taskShow", {id: this.id}))
                        break
                }
            }

            this.cancel = () => {
                if ($window.history.length > 2)
                    $window.history.back();
                else {
                    $state.go('home');
                }
            }

            $scope.$on('task.updated', () => $state.reload());
            $scope.$on('task.deleted', () => this.cancel());
        }
    })
